module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('el-form', {
    staticClass: "header-info",
    attrs: {
      "inline": ""
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.server.name) + "\n      ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Version"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.server.version) + "\n      ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Status"
    }
  }, [_c('el-tag', [_vm._v(_vm._s(_vm.server.status))]), _vm._v(" "), _c('el-button-group', [_c('el-button', {
    attrs: {
      "size": "small",
      "disabled": this.server.status !== 'stopped',
      "loading": this.server.status === 'starting'
    },
    on: {
      "click": function($event) {
        _vm.$store.dispatch('startServer', _vm.server.name)
      }
    }
  }, [_vm._v("Start")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "disabled": this.server.status !== 'started',
      "loading": this.server.status === 'stopping'
    },
    on: {
      "click": function($event) {
        _vm.$store.dispatch('stopServer', _vm.server.name)
      }
    }
  }, [_vm._v("Stop")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "value": _vm.current
    },
    model: {
      value: (_vm.current),
      callback: function($$v) {
        _vm.current = $$v
      },
      expression: "current"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Console",
      "name": "console"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Player",
      "name": "player"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Setting",
      "name": "setting"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "component"
  }, [_c('keep-alive', [_c('server-' + _vm.current, {
    tag: "component",
    attrs: {
      "server": _vm.server
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-609d99fe"}!./~/.11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/nav/server/Server.vue
// module id = 169
// module chunks = 1